import React, { useState } from "react";
import { Button, Container } from "react-bootstrap";
import { HourPackageList } from "../components/HourPackageList";
import { HourPackageForm } from "../components/HourPackageForm";

function PaquetesPage() {
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);

  const openNew = () => {
    setEditing(null);
    setShowForm(true);
  };

  const openEdit = (pkg) => {
    setEditing(pkg);
    setShowForm(true);
  };

  const handleHide = () => {
    setShowForm(false);
    setEditing(null);
  };

  return (
    <Container fluid className="py-3">
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        <h4 className="mb-0">Paquetes y precios</h4>
        <Button
          variant="primary"
          onClick={openNew}
          style={{ minHeight: 44 }}
        >
          + Nuevo paquete
        </Button>
      </div>

      <HourPackageList onEdit={openEdit} />

      <HourPackageForm
        show={showForm}
        onHide={handleHide}
        editing={editing}
      />
    </Container>
  );
}

export { PaquetesPage };
